export default "__VITE_ASSET__Bihov409__"